module.exports = __webpack_public_path__ + "img/caret-down-sr.ebe16183.svg";